import axios from '@/axiosConnection'
const moment = require('moment')

export default {
  namespaced: true,
  state: {
    items: [],
    copy: {},
    types: [{
        value: "online",
        text: "Site internet"
      },
      {
        value: "office",
        text: "Comptoir"
      },
      {
        value: "exchange",
        text: "Échange"
      }
    ],
    renting_retrieving_places: [
      {
        value: "agency",
        text: "Livraison en agence"
      },
      {
        value: "project",
        text: "Livraison sur chantier"
      },
      {
        value: "other",
        text: "Autre lieu"
      }
    ],
    renting_retrieving_places_colors: {
      agency: "#2b97fc",
      project: "#fe8d0b",
      other: "#cd0bfe"
    }
  },
  mutations: {
    prepareCopy(state, copy) {
      state.copy = copy
    },
    emptyCopy(state) {
      state.copy = {}
    }
  },
  getters: {
    getAll: state => state.items,
    getByStatus: state => status => state.items.filter(item => item.status_id == status || item.status.id == status),
    getByStatusSlug: state => status => state.items.filter(item => item.status_slug == status || item.status.status_slug == status),
    getByDate: state => (dateStart, dateEnd) => state.items.filter(item => moment(item.axiloc_creation_date).isBetween(moment(dateStart, dateEnd))),
    getItem: state => id => state.items.find(item => item.id == id),
    getTypes: state => state.types,
    getType: state => type => state.types.find(item => item.value == type),
    getCopy: state => state.copy,
    getRentingRetrievingPlaces: state => state.renting_retrieving_places,
    getRentingRetrievingPlaceBySlug: state => slug => state.renting_retrieving_places.find(item => item.value == slug),
    getRentingRetrievingPlaceColorBySlug: state => slug => state.renting_retrieving_places_colors[slug],
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'renting',
        api_data_path: 'rentings',
        namespace: 'renting'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getRentingDashboard: (context) => {
      return new Promise(function (resolve, reject) {
        axios.get("renting/dashboard")
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            toastr.error("Le chargement de la liste a échoué")
            reject(error)
          })
      })
    },
    /**
     * Charge tous les items via l'API dans le state avec des données limitées. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAllForSelect: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'renting/index/simple',
        api_data_path: 'rentings',
        namespace: 'renting'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'renting',
        namespace: 'renting',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    addItem(context, item) {
      let params = {
        api_url: 'renting',
        namespace: 'renting',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'renting',
        namespace: 'renting',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'renting',
        namespace: 'renting',
        id: id,
        ignoreGetAll: true
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    },
    addProducts(context, item) {
      let params = {
        api_url: 'renting/addProducts',
        namespace: 'renting',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/renting.js